import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles((theme) => ({
  root: {
  },
  media: {
  },

  marginTop: {
    marginTop: '80px',
    padding: '40px 0 80px',
    [theme.breakpoints.down("md")]: {
      marginTop: '80px',
      padding: '20px 15px',
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: '80px',
      padding: '20px 15px',
    },
  },
  header: {
    fontSize: '25px',
    fontFamily: 'Gilroy-ExtraBold, serif',
    marginBottom: '30px',
    display: 'flext',
    textAlign: 'left',
    width: '100%',
    [theme.breakpoints.down("md")]: {
      fontSize: '25px',
      marginBottom: '20px',
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: '25px',
      marginBottom: '20px',
    },
  },
  subHeader: {
    fontSize: '18px',
    fontFamily: 'Gilroy-ExtraBold, serif',
    marginBottom: '15px',
    display: 'flext',
    textAlign: 'left',
    width: '100%',
    textDecoration: 'underline',
    marginTop: '30px',
    [theme.breakpoints.down("md")]: {
      fontSize: '18px',
      marginTop: '10px',
      marginBottom: '15px',
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: '18px',
      marginTop: '10px',
      marginBottom: '15px',
    },
  },
  italic: {
    fontSize: '14px',
    fontFamily: 'Gilroy-Light, serif',
    marginBottom: '0px',
    fontStyle: 'italic',
    width: '100%',
    [theme.breakpoints.down("md")]: {
      fontSize: '16px',
      marginBottom: '0px',
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: '16px',
      marginBottom: '0px',
    },
  },
  para: {
    fontSize: '14px',
    fontFamily: 'Gilroy-Light, serif',
    marginBottom: '15px',
    width: '100%',
    [theme.breakpoints.down("md")]: {
      fontSize: '14px',
      marginBottom: '10px',
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: '14px',
      marginBottom: '10px',
    },
  },
  list: {
    display: ' block',
    width: '100%',
    margin: '20px 0px 20px 40px',
    [theme.breakpoints.down("md")]: {
      margin: '10px 0px 10px 10px',
    },
    [theme.breakpoints.down("sm")]: {
      margin: '10px 0px 10px 20px',
    },
    '& > li': {
      fontSize: '14px',
      fontFamily: 'Gilroy-Light, serif',
      marginBottom: '15px',
      width: '100%',
      textAlign: 'left',
      [theme.breakpoints.down("md")]: {
        fontSize: '14px',
        marginBottom: '10px',
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: '14px',
        marginBottom: '10px',
      },
    },
  },
  link: {
    color: '#D62828',
    textDecoration: 'underline',
  },

}));
